



// Takes a data URI and returns the Data URI corresponding to the resized image at the wanted size.
function minifyimg(datas,width){
    return new Promise(function(resolve,reject){

        // We create an image to receive the Data URI
        var img = document.createElement('img');

        // When the event "onload" is triggered we can resize the image.
        img.onload = function()
        {        
            // We create a canvas and get its context.
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');

            // We set the dimensions at the wanted size.
            canvas.width = width;
            canvas.height = img.height/img.width*width;
            ctx.scale(canvas.width/img.width,canvas.height/img.height)//宽和高等比例缩小
            // We resize the image with the canvas method drawImage();
            ctx.drawImage(this, 0, 0);

            //var dataURI = canvas.toDataURL('image/jpeg', 0.6);

            // This is the return of the Promise
            //resolve(dataURI);
            resolve(canvas)
        };

        // We put the Data URI in the image's src attribute
        img.src = datas;

    })
}

export default minifyimg


// WEBPACK FOOTER //
// ./src/components/utility/commonfields/minifyimg.js